"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CurrencyModal;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _currencySelector = require("../../navigation/footer/currency-selector");
var _text = _interopRequireDefault(require("@ux/text"));
var _closeButton = _interopRequireDefault(require("@site/pattern-library-core/close-button"));
/* eslint-disable max-len */

const CurrencyModalWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CurrencyModalWrapper",
  class: "pl-ce097ku"
});
const ModalContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ModalContent",
  class: "pl-mv81jn7"
});
const ModalHeader = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ModalHeader",
  class: "pl-m9hu2o9"
});
const CurrencyList = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CurrencyList",
  class: "pl-ctrutrq"
});
const CurrencyListItem = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CurrencyListItem",
  class: "pl-c1qu5amo"
});

/**
 * CurrencyModal component.
 * @module CurrencyModal
 *
 * @param {Object} props React props
 * @param {string} props.title The item's title
 * @param {string} props.content Content text
 * @param {array} props.primaryCurrencies Primary Currencies List
 * @param {array} props.allCurrencies All Currencies List
 * @param {Object} props.selectedCurrency Selected Currency
 * @param {string} props.setCurrencyUrl Url to GUI for setting new currency (Ex: https://gui.godaddy.com/preference/currency/set)
 * @param {boolean} props.showModal Show Modal
 * @param {function} props.setShowModal Set Show Modal
 * @param {string} props._name Tracking name
 * @returns {React.ReactElement} CurrencyModal component.
 * @public
 */
function CurrencyModal({
  _name,
  title,
  content,
  setCurrencyUrl,
  selectedCurrency,
  primaryCurrencies,
  allCurrencies,
  showModal,
  setShowModal
}) {
  return /*#__PURE__*/_react.default.createElement(CurrencyModalWrapper, (0, _extends2.default)({
    "data-cy": "currency-modal",
    "data-show": showModal,
    "aria-hidden": !showModal
  }, _patternLibraryUtils.tracking.create(_name, false, false)), /*#__PURE__*/_react.default.createElement(ModalContent, null, /*#__PURE__*/_react.default.createElement(_closeButton.default, {
    onClose: () => setShowModal(false)
  }), /*#__PURE__*/_react.default.createElement(ModalHeader, null, /*#__PURE__*/_react.default.createElement(_text.default.div, {
    as: "title",
    text: title
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, content), /*#__PURE__*/_react.default.createElement(CurrencyList, null, primaryCurrencies?.map(({
    id,
    symbol,
    description
  }, i) => /*#__PURE__*/_react.default.createElement(CurrencyListItem, {
    className: selectedCurrency?.id === id && 'selected',
    key: i,
    "data-currencyid": id,
    onClick: () => (0, _currencySelector.currencyRedirect)(id, setCurrencyUrl)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "before-currency"
  }, selectedCurrency?.id === id && /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "checkmark",
    fill: _intents.default.ux.actionOptionChosen.foregroundColor
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "currency-symbol"
  }, symbol.Value), /*#__PURE__*/_react.default.createElement("span", {
    className: "currency-description"
  }, description))), /*#__PURE__*/_react.default.createElement("span", {
    className: "divider"
  }), allCurrencies?.map(({
    id,
    symbol,
    description
  }, i) => /*#__PURE__*/_react.default.createElement(CurrencyListItem, {
    key: i,
    "data-currencyid": id,
    className: selectedCurrency?.id === id && 'selected',
    onClick: () => (0, _currencySelector.currencyRedirect)(id, setCurrencyUrl)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "before-currency"
  }, selectedCurrency?.id === id && /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "checkmark",
    fill: _intents.default.ux.actionOptionChosen.foregroundColor
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "currency-symbol"
  }, symbol.Value), /*#__PURE__*/_react.default.createElement("span", {
    className: "currency-description"
  }, description)))))));
}
CurrencyModal.propTypes = {
  _name: _propTypes.default.string,
  title: _propTypes.default.string,
  content: _propTypes.default.string,
  showModal: _propTypes.default.bool,
  setShowModal: _propTypes.default.func,
  setCurrencyUrl: _propTypes.default.string,
  selectedCurrency: _propTypes.default.shape({
    id: _propTypes.default.string,
    symbol: _propTypes.default.shape({
      HasValue: _propTypes.default.bool,
      Value: _propTypes.default.string
    }),
    description: _propTypes.default.string
  }),
  primaryCurrencies: _propTypes.default.arrayOf({
    id: _propTypes.default.string,
    symbol: _propTypes.default.shape({
      HasValue: _propTypes.default.bool,
      Value: _propTypes.default.string
    }),
    description: _propTypes.default.string
  }),
  allCurrencies: _propTypes.default.arrayOf({
    id: _propTypes.default.string,
    symbol: _propTypes.default.shape({
      HasValue: _propTypes.default.bool,
      Value: _propTypes.default.string
    }),
    description: _propTypes.default.string
  })
};